module.exports = __webpack_public_path__ + "static/img/jxhw.cd5fd84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jxhw.png
// module id = 8JAG
// module chunks = 23